import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft, Award, Instagram } from "lucide-react";
import Gallery from "../components/Gallery";
import { ANIMATION_PROJECTS } from "../data/portfolio";

export default function AnimationProject() {
  const { slug } = useParams();
  const project = ANIMATION_PROJECTS.find((p) => p.slug === slug);

  if (!project) return <Navigate to="/animation" replace />;

  return (
    <div data-testid={`anim-project-${project.slug}`}>
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10 pt-10">
        <Link
          to="/animation"
          data-testid="anim-back"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[var(--muted)] hover:text-[var(--ember)] transition-colors"
        >
          <ArrowLeft size={14}/> All Projects
        </Link>
      </div>

      {project.trailer && (
        <div className="max-w-[1600px] mx-auto px-6 lg:px-10 mb-12">
          <div className="aspect-video w-full overflow-hidden">
            <iframe
              src={project.trailer}
              title={`${project.title} — Trailer`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            />
          </div>
        </div>
      )}

      <Gallery
        title={project.title}
        subtitle={`${project.role} · ${project.studio} · ${project.year}`}
        items={project.items}
        header={
          <>
            {project.awards && project.awards.length > 0 && (
              <div
                data-testid="project-awards"
                className="mt-8 max-w-2xl border-l-2 border-[var(--ember)] pl-5 reveal"
              >
                <div className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[var(--ember)] mb-3">
                  <Award size={14}/> Accolades
                </div>
                <ul className="space-y-1.5 text-[var(--bone)] text-sm md:text-base leading-relaxed">
                  {project.awards.map((a) => (
                    <li key={a} className="flex gap-3">
                      <span className="text-[var(--gold)] mt-1">✦</span>
                      <span>{a}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {project.instagram && (
              <a
                href={project.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[var(--muted)] hover:text-[var(--ember)] transition-colors reveal"
              >
                <Instagram size={14}/> Instagram
              </a>
            )}
          </>
        }
      />
    </div>
  );
}
